import { useAuthStore } from '../store/authStore'

// Thin hook over the store — no extra fetch needed since initAuth loads
// all households on sign-in.
export const useHouseholds = () => {
  const households        = useAuthStore((s) => s.households)
  const household         = useAuthStore((s) => s.household)
  const switchHousehold   = useAuthStore((s) => s.switchHousehold)
  const refreshHouseholds = useAuthStore((s) => s.refreshHouseholds)

  return { households, currentHousehold: household, switchHousehold, refreshHouseholds }
}
